import { render } from "./loginInput.vue?vue&type=template&id=fafe39f0"
import script from "./loginInput.vue?vue&type=script&lang=js"
export * from "./loginInput.vue?vue&type=script&lang=js"

import "./loginInput.vue?vue&type=style&index=0&id=fafe39f0&lang=css"

import exportComponent from "/home/runner/work/user-ui/user-ui/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__